import { render, staticRenderFns } from "./FailuresSummary.vue?vue&type=template&id=613a27b4&"
import script from "./FailuresSummary.vue?vue&type=script&lang=js&"
export * from "./FailuresSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports